import { Component, Input, OnInit, Renderer2, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormsModule, NgForm, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { fuseAnimations } from '@fuse/animations';
import {FuseAlertType } from '@fuse/components/alert';
import { AuthService } from 'app/core/auth/auth.service';
import { CommonModule } from '@angular/common';
import { ConfigService } from 'app/services/config.service';
import { FileService } from 'app/services/file.service';
import tinycolor from 'tinycolor2';
import { TranslocoPipe, TranslocoService} from '@ngneat/transloco';
import { RouterModule } from '@angular/router';
import { TranslocoHttpLoader } from '../../../core/transloco/transloco.http-loader';
import { LanguagesComponent } from '../../../layout/common/languages/languages.component';
import { FormService } from '../../../services/form.service';
import { DrakeSharedService } from '../../../services/drake-shared.service';
import { PageService } from '../../../services/page.service';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'environments/environment';
import { GridService } from 'app/services/grid.service';



@Component({
    selector: 'auth-sign-up',
    templateUrl: './sign-up.component.html',
    styleUrls: ['./sign-up.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    providers: [TranslocoService, TranslocoPipe],
    standalone: true,
    imports: [
        RouterLink, FormsModule, ReactiveFormsModule, MatFormFieldModule, 
        MatInputModule, MatButtonModule, MatIconModule, MatCheckboxModule,
        MatProgressSpinnerModule, CommonModule, TranslocoPipe, RouterModule, LanguagesComponent
    ],
})
export class AuthSignUpComponent implements OnInit {
    backgroundColor: string;
    logoUrl: string;
    logoId: string;
    textColor: string;
    introductionHtml: string;
    introductionCss: string;
    customColor: string;
    registrationFields: any[] = [];
    private route: ActivatedRoute



    @Input() scope!: string;
    @Input() id!: string;
    @Input() isDefault: boolean = true;
    public userId: string;

    public viewConfig: any;

    //public pageData: any;
    //public baseData: any = {};

    @ViewChild('signUpNgForm') signUpNgForm: NgForm;

    alert: { type: FuseAlertType; message: string } = {
        type: 'success',
        message: '',
    };
    signUpForm: UntypedFormGroup;
    showAlert: boolean = false;

    constructor(
        private _authService: AuthService,
        private _formBuilder: UntypedFormBuilder,
        private _router: Router,
        private configService: ConfigService,
        private fileService: FileService,
        private translocoService: TranslocoService,
        private translocoLoader: TranslocoHttpLoader,
        private formService: FormService,
        private drakeSharedService: DrakeSharedService,
        private pageService: PageService,
        private renderer: Renderer2,
        private sanitizer: DomSanitizer,
        private translocoPipe: TranslocoPipe,
        private gridService: GridService
    ) {
        this.configService.getAnonymousToken().subscribe(response => {
            this._authService.accessToken = response.token;
        }, error => {
            console.error('Error getting anonymous token:', error);
        });
    }

    ngOnInit(): void {

        this._router.navigate(['sign-up/a/REGISTRATION/f'], { skipLocationChange: true });
        this.loadBranding('DEFAULT'); 

    }

    ngAfterViewInit() {


         this.configService.getAnonymousToken().subscribe(response => {
             this._authService.accessToken = response.token;
             console.log("TOKEN ANONIMO: ", this._authService.accessToken);
             this.configService.getLanguages().subscribe((result: any) => {
                this.translocoService.setAvailableLangs(result.data.map(l => { return { id: l.Lingua.value, label: l.Lingua.text } }));
                 var lang = this.translocoService.getActiveLang();
                 if (localStorage.lang)
                     lang = localStorage.lang;
                 this.translocoService.setActiveLang(lang);
                 this.translocoService.load(lang).subscribe(a => {
                     this.translocoService.selectTranslation(lang);
                 });
             });
        }, error => {
            console.error('Error getting anonymous token:', error);
        });


     }


    loadBranding(id: string): void {
        console.log("Loading branding with ID:", id);
        this.configService.getBranding(id).subscribe({
            next: (config: any) => {
                console.log("Received branding config:", config);
                if (config) {
                    this.backgroundColor = config.brdColor1 || this.backgroundColor;
                    this.logoId = config.brdLogo1 || this.logoUrl;
                    this.textColor = config.brdColor2 || this.textColor;
                    this.introductionHtml = config.brdSigninHtml || this.introductionHtml;
                    this.customColor = config.brdColor3 || this.customColor;

                    this.introductionCss = config.brdAppCss || this.introductionCss;

                    // Sanitize if needed     
                    const styleElement = this.renderer.createElement('style');     const sanitizedCss = this.sanitizer.sanitize(1, this.introductionCss);
                    this.renderer.setProperty(styleElement, 'textContent', sanitizedCss);
                    this.renderer.appendChild(document.head, styleElement);

                    this.setCustomColor(this.backgroundColor, 'background');
                    this.setCustomColor(this.textColor, 'text');
                    this.setCustomColor(this.customColor, 'custom');

                    if (this.logoId) {
                        this.fileService.readFileAsBase64String(this.logoId).subscribe((result: any) => {
                            console.log("logo ", result);
                            this.logoUrl = result.dataUrl;
                            config.brdLogo1 = result.dataUrl
                            localStorage.setItem('branding', JSON.stringify(config));
                        });
                    } else {
                        localStorage.setItem('branding', JSON.stringify(config));
                    }

                    console.log("Branding saved in localStorage:", localStorage.getItem('branding'));
                } else {
                    console.warn("Branding config is undefined or null");
                }
            },
            error: (error: any) => {
                console.error('Error loading branding:', error);
            },
            complete: () => {
                console.log('Branding loading completed');

                var lang = this.translocoService.getActiveLang();
                if (localStorage.lang) {
                    lang = localStorage.lang;
                }
                this.translocoService.setActiveLang(lang);
                this.translocoService.load(lang).subscribe(a => {
                    this.translocoService.selectTranslation(lang);
                });
            }
        });
    }

    setCustomColor(color: string, name: string): void {
        document.documentElement.style.setProperty(`--${name}-color`, color);
        document.documentElement.style.setProperty(`--${name}-light`, this.lighten(color, 20));
        document.documentElement.style.setProperty(`--${name}-dark`, this.darken(color, 20));
        document.documentElement.style.setProperty(`--${name}-lighter`, this.lighten(color, 40));
        document.documentElement.style.setProperty(`--${name}-darker`, this.darken(color, 40));
    }

    lighten(color: string, percent: number): string {
        return tinycolor(color).lighten(percent).toString();
    }

    darken(color: string, percent: number): string {
        return tinycolor(color).darken(percent).toString();
    }

    generateUserSid(): string {
        return 'user-' + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    }





    signUp(): void {

        debugger;

        //console.log("MAIN RECORD: ", this.drakeSharedService.mainRecord, " PAGE DATA ", this.drakeSharedService.currentPageData);

        var invalidFields = this.formService.applyValidation(this.drakeSharedService.mainRecord, "REGISTRATION", this.drakeSharedService.currentPageData);
        if (invalidFields.length) {
            var notification = this.translocoPipe.transform("notification.error.signUp.invalidFields");
            this.drakeSharedService.showTemporaryNotification(notification, 'error');
            return;
        }
        
        const userSid = this.generateUserSid();
        const signUpData = {
            data: {
                ...this.drakeSharedService.mainRecord,
                UserSid: userSid,
                AutoApprove: environment.autoApprove,
                Status: "WAITING",
                EmailConfirmed: false
            }
        };


        this._authService.signUp(signUpData).subscribe(
            (response) => {
                /*if(response.error.errorMessage){
                    this.drakeSharedService.showTemporaryNotification(response.errorMessage, "error");
                    return;
                }*/
                sessionStorage.setItem('UserSid', response.userSid);
                sessionStorage.setItem('FactorSid', response.factorSid);
                sessionStorage.setItem('Username', signUpData.data.Email);

                /*if(environment.enableTwoFactor)
                    this._router.navigate(['/registration-step2']);
                else{
                    this.drakeSharedService.showTemporaryNotification("Account registrato con successo", "success");
                    //this._router.navigate(['/sign-in']);
                }*/
                    var notification = this.translocoPipe.transform("notification.success.signUp.register");
                this.drakeSharedService.showTemporaryNotification(notification, "success");
                this._router.navigate(['/confirmation-required']);


            },
            (response) => {
                if(response.error.errors.length){
                    switch (response.error.errors[0]){
                        case "EMLNOTCONF":
                            var notification = this.translocoPipe.transform("notification.error.signUp.emailNotConfirmed")
                            this.drakeSharedService.showTemporaryNotification(notification, "error");
                            /*this.drakeSharedService.mainRecord.ResendEmail = true;
                            var data = { "ResendEmail": true};
                            var query = {"Email": this.drakeSharedService.mainRecord.Email}
                            this.gridService.updateScopeData("REGISTRATION", "UPDATE", data, query).subscribe((result: any) => {
                            console.log("callresult", result);});*/
                           break;
                        case "EMLUSED":
                            var notification = this.translocoPipe.transform("notification.error.signUp.emailAlreadyUsed")
                            this.drakeSharedService.showTemporaryNotification(notification, "error");
                            break;
                        case "PIVAUSED":
                            var notification = this.translocoPipe.transform("notification.error.signUp.pIvaAlreadyUsed")
                            this.drakeSharedService.showTemporaryNotification(notification, "error");
                            break;
                    }
                    return;
                }
            }
        );
    }

    
}
